import Icon, { IconProps } from 'approot/shared/icons/icon';

import { ReactComponent as CorrectDim } from './icon_correct_dim.svg';

const IconCorrectDim = (props: IconProps) => {
  return <Icon {...props} Svg={CorrectDim} />;
};

export default IconCorrectDim;
